import React from 'react';
import PropTypes from 'prop-types';
import styles from './FeaturedProductsText.module.css';

const FeaturedProductText = ({
  productCountDisplay,
  totalProductCount,
  displayProductCount,
}) => {
  return (
    <div className={styles.textContainer}>
      <h1>Discover Exceptional Finds</h1>
      <p>
        Shop a curated assortment featuring our
        <span style={{ whiteSpace: 'nowrap' }}> favorite products.</span>
      </p>
      {displayProductCount && (
        <p id="featured-product-count">
          Showing <strong>{productCountDisplay}</strong>
          {` of ${totalProductCount}`}
        </p>
      )}
    </div>
  );
};

FeaturedProductText.propTypes = {
  productCountDisplay: PropTypes.string.isRequired,
  totalProductCount: PropTypes.number.isRequired,
  displayProductCount: PropTypes.bool.isRequired,
};

export default FeaturedProductText;
